// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"28":"92eee0d85f438962","174":"ef2ec4eab910508f","230":"4d9ef0b851215df5","666":"8ea4aa8418020078","990":"53c4a1b0470d7237"}[chunkId] + ".js";
};